var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function uploadElementMultiple($compile) {
        return {
            transclude: true,
            templateUrl: 'views/partials/elements/uploadElementMultiple.html',
            compile: function compile(tElement, tAttrs) {
                return {
                    pre: function preLink(scope, tElement, tAttrs) {
                        scope.operationname = tAttrs.operationname;
                        scope.uploadvariabledefinition = JSON.parse(tAttrs.uploadvariabledefinition);
                        var fileExtSupported = new Array();
                        Object.keys(scope.uploadvariabledefinition).forEach(function (key) {
                            fileExtSupported.push(key);
                        });
                        var fileExtSupportedString = "";
                        for (var entry in fileExtSupported) {
                            fileExtSupportedString += fileExtSupported[entry].toUpperCase() + " ";
                        }
                        fileExtSupportedString = fileExtSupportedString.substring(0, fileExtSupportedString.length - 1);
                        scope.buttonclass = tAttrs.buttonclass;
                        scope.secondstepbuttonlabel = tAttrs.secondstepbuttonlabel;
                        var dropAreaTextToDisplay = "";
                        fileExtSupportedString = fileExtSupportedString.toLowerCase().split(" ").join(", ");
                        if (!(tAttrs.dropareatext === undefined)
                            && tAttrs.dropareatext != null
                            && tAttrs.dropareatext != "") {
                            dropAreaTextToDisplay += tAttrs.dropareatext;
                        }
                        else {
                            console.log("dropareatext: should be set in the HTML definition");
                        }
                        dropAreaTextToDisplay += "(allowed formats are: " + fileExtSupportedString + ")";
                        if (!(tAttrs.optionaladditionaldropareatext === undefined)
                            && tAttrs.optionaladditionaldropareatext != null
                            && tAttrs.optionaladditionaldropareatext != "") {
                            dropAreaTextToDisplay += tAttrs.optionaladditionaldropareatext;
                        }
                        if (dropAreaTextToDisplay.charAt(dropAreaTextToDisplay.length - 1) != ".") {
                            dropAreaTextToDisplay += ".";
                        }
                        scope.dropAreaText = dropAreaTextToDisplay;
                        scope.optionalwebservicehint = tAttrs.optionalwebservicehint;
                        scope.optionaladditionalcheckboxmessage = tAttrs.optionaladditionalcheckboxmessage;
                        if (tAttrs.pairdefinition.lastIndexOf("null") != -1)
                            scope.pairdefinition = null;
                        else
                            scope.pairdefinition = JSON.parse(tAttrs.pairdefinition);
                    }
                };
            }
        };
    }
    BASWebServices.uploadElementMultiple = uploadElementMultiple;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=uploadElementMultiple.js.map